import { toast } from 'sonner';

import type { Preset } from '@/api';
import { Select } from '@/components/ui';

const same = (a: unknown, b: unknown) => JSON.stringify(a) === JSON.stringify(b);

/** Replace the params with a definition's defaults or one of its presets; nothing when it has none. */
export function PresetPicker({ defaults, presets, onPick }: { defaults: unknown; presets: Preset[]; onPick: (params: unknown) => void }) {
	if (!presets.length) return null;
	return (
		<Select
			aria-label="Load a preset"
			className="h-7 w-auto py-0 text-xs"
			value=""
			onChange={(e) => {
				const p = presets.find((x) => x.id === e.target.value);
				onPick(structuredClone(p ? p.params : defaults));
				toast.success(p ? `Loaded preset “${p.name}”` : 'Loaded the defaults');
			}}
		>
			<option value="" disabled>
				Load preset…
			</option>
			<option value="defaults">Defaults</option>
			{presets.map((p) => (
				<option key={p.id} value={p.id}>
					{p.name}
				</option>
			))}
		</Select>
	);
}

/** Which preset the params match, with what it is for. */
export function PresetNote({ params, presets }: { params: unknown; presets: Preset[] }) {
	const p = presets.find((x) => same(x.params, params));
	if (!p) return null;
	return (
		<p className="mb-4 rounded-md bg-accent-soft px-3 py-2 text-xs">
			<span className="font-medium">Preset “{p.name}”.</span> {p.description}
		</p>
	);
}
